export default {
  "brand.name": "AllChinaBuy Spreadsheet",
  "brand.tagline": "Produktresearch, organiseret",

  "nav.home": "Hjem",
  "nav.buyingGuide": "Købsguide",
  "nav.guide": "Spreadsheet-guide",
  "nav.categories": "Kategorier",
  "nav.faq": "FAQ",

  "buttons.allchinabuySpreadsheet": "AllChinaBuy Spreadsheet",
  "buttons.buyItNow": "Køb nu",
  "buttons.viewCategory": "Se kategori",
  "buttons.browse": "Se alle",

  "categories.shoes": "Sko",
  "categories.hoodies": "Hættetrøjer / Sweatshirts",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jakker",
  "categories.pants": "Bukser / Shorts",
  "categories.headwear": "Hovedbeklædning",
  "categories.sets": "Sæt",
  "categories.underwear": "Undertøj",
  "categories.jersey": "Trøjer",
  "categories.accessories": "Tilbehør",
  "categories.bags": "Tasker",
  "categories.belts": "Bælter",
  "categories.perfumes": "Parfumer",
  "categories.other": "Andre ting",

  "languages.en": "English",
  "languages.fr": "Français",
  "languages.da": "Dansk",
  "languages.de": "Deutsch",

  "footer.disclaimer": "Uafhængig ressource · Ikke det officielle AllChinaBuy-websted",
  "footer.rights": "Alle rettigheder forbeholdes.",
  "footer.explore": "Udforsk",
  "footer.resources": "Ressourcer",
  "footer.backHome": "Tilbage til forsiden",
  "footer.browseCategories": "Gennemse kategorier",
};